import React, { useEffect, useState } from "react";
import axios from "axios";
import API from "../config/config";

const Payments = () => {
  const [payments, setPayments] = useState([]);

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const response = await axios.get("/api/payments");
        setPayments(response.data);
      } catch (error) {
        console.error("Error fetching payments:", error);
      }
    };

    fetchPayments();
  }, []);

  return (
    <div className="bg-white p-5 rounded-lg shadow">
      <h2 className="text-2xl font-bold mb-4">Payments</h2>
      <table className="min-w-full bg-white">
        <thead>
          <tr>
            <th className="py-2">Payment ID</th>
            <th className="py-2">Amount</th>
            <th className="py-2">Status</th>
            <th className="py-2">Date</th>
          </tr>
        </thead>
        <tbody>
          {payments.map((payment) => (
            <tr key={payment._id}>
              <td className="py-2">{payment._id}</td>
              <td className="py-2">₹{payment.amount}</td>
              <td className="py-2">{payment.status}</td>
              <td className="py-2">
                {new Date(payment.createdAt).toLocaleDateString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Payments;
